"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-explicit-any */
const yup = __importStar(require("yup"));
yup.addMethod(yup.object, 'unique', function (field, message) {
    return this.test('unique', message, function (array) {
        if (!array) {
            return true;
        }
        else {
            const uniqueData = Array.from(new Set(array.map((row) => { var _a; return (_a = row[field]) === null || _a === void 0 ? void 0 : _a.toLowerCase(); })));
            const isUnique = array.length === uniqueData.length;
            if (isUnique) {
                return true;
            }
            const index = array.findIndex((row, i) => { var _a; return ((_a = row[field]) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== uniqueData[i]; });
            if (array[index][field] === '') {
                return true;
            }
            return this.createError({
                path: `${this.path}.${index}.${field}`,
                message
            });
        }
    });
});
yup.addMethod(yup.object, 'uniqueProperty', function (propertyName, message) {
    return this.test('unique', message, function (value) {
        if (!value || !value[propertyName]) {
            return true;
        }
        if (this.parent
            .filter((v) => v !== value)
            .some((v) => v[propertyName] === value[propertyName])) {
            throw this.createError({
                path: `${this.path}.${propertyName}`
            });
        }
        return true;
    });
});
exports.default = yup;
